import axios from "axios";
import instance from "../../../helpers/AxiosInterceptor";

export const listVvinale = () => {
    return instance.get(`/settings/vvinale/list`);
};

export const findVvinale = (id) => {
    return instance.get(`/settings/vvinale/find/${id}`);
};

export const createVvinale = (request) => {
    return instance.post(`/settings/vvinale/create`, JSON.stringify(request));
};

export const updateVvinale = (request) => {
    return instance.put(`/settings/update`, JSON.stringify(request));
};



